import { MatrixRoster } from './MatrixRoster'

/**
 * Balances tab — the read-only "everyone's balances in one page" roster,
 * showing each employee's remaining balance per leave type. A thin wrapper
 * over the shared {@link MatrixRoster} (metric="remaining"); row click opens
 * the breakdown pop-up, and the per-row Adjust button opens it in edit mode.
 */
export function BalancesTab(): JSX.Element {
  return <MatrixRoster metric="remaining" testIdPrefix="balances" />
}
